module.exports = __webpack_public_path__ + "static/benefitIcon2.55609bdd.svg";